<template>
  <div class="intro-y box p-5">
    <div class="mt-3">
      <label for="monday" class="form-label w-full flex flex-col sm:flex-row">
        {{ $t('common.days.monday') }}
        <span class="sm:ml-auto mt-1 sm:mt-0 text-xs text-gray-600">
          {{ $t('form.constraint.openHours') }}<br />{{
            $t('form.constraint.openHoursFormat')
          }}
        </span>
      </label>
      <input
        id="openMonday"
        v-model="validate.openMonday.$model"
        name="openMonday"
        class="form-check-switch"
        type="checkbox"
      />
      <input
        id="monday"
        v-model.trim="validate.monday.$model"
        type="text"
        name="monday"
        class="
              intro-y
              form-control
              py-3
              px-4
              box
              pr-10
              placeholder-theme-13
            "
        :class="{ 'border-theme-6': validate.monday.$error }"
        placeholder="HH:mm-HH:mm"
        @input="$emit('update:openHours', getData())"
        v-show="validate.openMonday.$model !== false"
      />
      <template v-if="validate.monday.$error">
        <div
          v-for="(error, index) in validate.monday.$errors"
          :key="index"
          class="text-theme-6 mt-2"
        >
          {{ $t(error.$message) }}
        </div>
      </template>
    </div>
    <div class="mt-3">
      <label for="tuesday" class="form-label w-full flex flex-col sm:flex-row">
        {{ $t('common.days.tuesday') }}
      </label>
      <input
        id="openTuesday"
        v-model="validate.openTuesday.$model"
        name="openTuesday"
        class="form-check-switch"
        type="checkbox"
      />
      <input
        id="tuesday"
        v-model.trim="validate.tuesday.$model"
        type="text"
        name="tuesday"
        class="
              intro-y
              form-control
              py-3
              px-4
              box
              pr-10
              placeholder-theme-13
            "
        :class="{ 'border-theme-6': validate.tuesday.$error }"
        placeholder="HH:mm-HH:mm"
        @input="$emit('update:openHours', getData())"
        v-show="validate.openTuesday.$model !== false"
      />
      <template v-if="validate.tuesday.$error">
        <div
          v-for="(error, index) in validate.tuesday.$errors"
          :key="index"
          class="text-theme-6 mt-2"
        >
          {{ $t(error.$message) }}
        </div>
      </template>
    </div>
    <div class="mt-3">
      <label
        for="wednesday"
        class="form-label w-full flex flex-col sm:flex-row"
      >
        {{ $t('common.days.wednesday') }}
      </label>
      <input
        id="openWednesday"
        v-model="validate.openWednesday.$model"
        name="openWednesday"
        class="form-check-switch"
        type="checkbox"
      />
      <input
        id="wednesday"
        v-model.trim="validate.wednesday.$model"
        type="text"
        name="wednesday"
        class="
              intro-y
              form-control
              py-3
              px-4
              box
              pr-10
              placeholder-theme-13
            "
        :class="{ 'border-theme-6': validate.wednesday.$error }"
        placeholder="HH:mm-HH:mm"
        @input="$emit('update:openHours', getData())"
        v-show="validate.openWednesday.$model !== false"
      />
      <template v-if="validate.wednesday.$error">
        <div
          v-for="(error, index) in validate.wednesday.$errors"
          :key="index"
          class="text-theme-6 mt-2"
        >
          {{ $t(error.$message) }}
        </div>
      </template>
    </div>
    <div class="mt-3">
      <label for="thursday" class="form-label w-full flex flex-col sm:flex-row">
        {{ $t('common.days.thursday') }}
      </label>
      <input
        id="openThursday"
        v-model="validate.openThursday.$model"
        name="openThursday"
        class="form-check-switch"
        type="checkbox"
      />
      <input
        id="thursday"
        v-model.trim="validate.thursday.$model"
        type="text"
        name="thursday"
        class="
              intro-y
              form-control
              py-3
              px-4
              box
              pr-10
              placeholder-theme-13
            "
        :class="{ 'border-theme-6': validate.thursday.$error }"
        placeholder="HH:mm-HH:mm"
        @input="$emit('update:openHours', getData())"
        v-show="validate.openThursday.$model !== false"
      />
      <template v-if="validate.thursday.$error">
        <div
          v-for="(error, index) in validate.thursday.$errors"
          :key="index"
          class="text-theme-6 mt-2"
        >
          {{ $t(error.$message) }}
        </div>
      </template>
    </div>
    <div class="mt-3">
      <label for="friday" class="form-label w-full flex flex-col sm:flex-row">
        {{ $t('common.days.friday') }}
      </label>
      <input
        id="openFriday"
        v-model="validate.openFriday.$model"
        name="openFriday"
        class="form-check-switch"
        type="checkbox"
      />
      <input
        id="friday"
        v-model.trim="validate.friday.$model"
        type="text"
        name="friday"
        class="
              intro-y
              form-control
              py-3
              px-4
              box
              pr-10
              placeholder-theme-13
            "
        :class="{ 'border-theme-6': validate.friday.$error }"
        placeholder="HH:mm-HH:mm"
        @input="$emit('update:openHours', getData())"
        v-show="validate.openFriday.$model !== false"
      />
      <template v-if="validate.friday.$error">
        <div
          v-for="(error, index) in validate.friday.$errors"
          :key="index"
          class="text-theme-6 mt-2"
        >
          {{ $t(error.$message) }}
        </div>
      </template>
    </div>
    <div class="mt-3">
      <label for="saturday" class="form-label w-full flex flex-col sm:flex-row">
        {{ $t('common.days.saturday') }}
      </label>
      <input
        id="openSaturday"
        v-model="validate.openSaturday.$model"
        name="openSaturday"
        class="form-check-switch"
        type="checkbox"
      />
      <input
        id="saturday"
        v-model.trim="validate.saturday.$model"
        type="text"
        name="saturday"
        class="
              intro-y
              form-control
              py-3
              px-4
              box
              pr-10
              placeholder-theme-13
            "
        :class="{ 'border-theme-6': validate.saturday.$error }"
        placeholder="HH:mm-HH:mm"
        @input="$emit('update:openHours', getData())"
        v-show="validate.openSaturday.$model !== false"
      />
      <template v-if="validate.saturday.$error">
        <div
          v-for="(error, index) in validate.saturday.$errors"
          :key="index"
          class="text-theme-6 mt-2"
        >
          {{ $t(error.$message) }}
        </div>
      </template>
    </div>
    <div class="mt-3">
      <label for="sunday" class="form-label w-full flex flex-col sm:flex-row">
        {{ $t('common.days.sunday') }}
      </label>
      <input
        id="openSunday"
        v-model="validate.openSunday.$model"
        name="openSunday"
        class="form-check-switch"
        type="checkbox"
      />
      <input
        id="sunday"
        v-model.trim="validate.sunday.$model"
        type="text"
        name="sunday"
        class="
              intro-y
              form-control
              py-3
              px-4
              box
              pr-10
              placeholder-theme-13
            "
        :class="{ 'border-theme-6': validate.sunday.$error }"
        placeholder="HH:mm-HH:mm"
        @input="$emit('update:openHours', getData())"
        v-show="validate.openSunday.$model !== false"
      />
      <template v-if="validate.sunday.$error">
        <div
          v-for="(error, index) in validate.sunday.$errors"
          :key="index"
          class="text-theme-6 mt-2"
        >
          {{ $t(error.$message) }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { defineComponent, toRefs, reactive, computed } from 'vue'
import { helpers } from '@vuelidate/validators'
import { useVuelidate } from '@vuelidate/core'

export default defineComponent({
  props: {
    openHours: {
      type: Object,
      default: () => {}
    }
  },

  methods: {
    getData() {
      return this.formData
    },
    setData(data) {
      console.info(data)
      this.formData.openMonday = data.openMonday
      this.formData.monday = data.monday
      this.formData.openTuesday = data.openTuesday
      this.formData.tuesday = data.tuesday
      this.formData.openWednesday = data.openWednesday
      this.formData.wednesday = data.wednesday
      this.formData.openThursday = data.openThursday
      this.formData.thursday = data.thursday
      this.formData.openFriday = data.openFriday
      this.formData.friday = data.friday
      this.formData.openSaturday = data.openSaturday
      this.formData.saturday = data.saturday
      this.formData.openSunday = data.openSunday
      this.formData.sunday = data.sunday
    }
  },

  emits: ['update:openHours'],

  setup(props, { emit }) {
    const ohValidator = helpers.regex(
      /^([0-9]{2}:[0-9]{2}-[0-9]{2}:[0-9]{2})?(,[0-9]{2}:[0-9]{2}-[0-9]{2}:[0-9]{2})*$/
    )
    const formData = reactive(props.openHours)
    const rules = {
      openMonday: {},
      monday: {
        ohValidator: helpers.withMessage(
          'form.validation.ohValidator',
          ohValidator
        )
      },
      openTuesday: {},
      tuesday: {
        ohValidator: helpers.withMessage(
          'form.validation.ohValidator',
          ohValidator
        )
      },
      openWednesday: {},
      wednesday: {
        ohValidator: helpers.withMessage(
          'form.validation.ohValidator',
          ohValidator
        )
      },
      openThursday: {},
      thursday: {
        ohValidator: helpers.withMessage(
          'form.validation.ohValidator',
          ohValidator
        )
      },
      openFriday: {},
      friday: {
        ohValidator: helpers.withMessage(
          'form.validation.ohValidator',
          ohValidator
        )
      },
      openSaturday: {},
      saturday: {
        ohValidator: helpers.withMessage(
          'form.validation.ohValidator',
          ohValidator
        )
      },
      openSunday: {},
      sunday: {
        ohValidator: helpers.withMessage(
          'form.validation.ohValidator',
          ohValidator
        )
      }
    }
    const validate = useVuelidate(rules, toRefs(formData))

    const componentValue = computed({
      get: () => props.openHours,
      set: () => {
        emit('update:openHours', validate)
      }
    })

    return {
      validate,
      formData,
      componentValue
    }
  }
})
</script>
